import Grid from "@mui/material/Grid";
import ValidatorTextField from "@/src/components/FormFields/ValidatorTextField";
import { isPhoneNumberDefault, isRequired } from "@/src/services/validationRules";
import ValidatorSelectField from "@/src/components/FormFields/ValidatorSelectField";
import { MenuItem } from "@mui/material";
import React from "react";
import FormLegend from "@/src/components/Form/Common/FormLegend/FormLegend";
import { translate } from "@/src/services/translations/translations";
import { serviceTimes } from "@/src/services/formServiceFunctions";
import _map from "lodash/map";
import { FormDataTypes } from "@/src/types/FormDataTypes";
import { useForm } from "@/src/provider/Form/FormProvider";
import wizardStyle from "@/src/components/Form/wizardStyle";

type ContactProps = {
  path?: string;
  headline?: string;
  withContactTime?: boolean;
};

export default function Contact({ path = "customer", headline = "Wie können wir Sie telefonisch am besten erreichen?", withContactTime = true }: ContactProps) {
  const { values }: FormDataTypes = useForm();

  return (
    <>
      <Grid sx={wizardStyle.gridTopSpaced} size={12}>
        <FormLegend>{headline}</FormLegend>
      </Grid>
      <Grid
        sx={withContactTime ? wizardStyle.gridSpace : undefined}
        size={{
          xs: 12,
          sm: withContactTime ? 6 : 12
        }}>
        <ValidatorTextField
          name={`${path}.telephone`}
          label={translate("person.telephone.label", values)}
          autoComplete="tel"
          validators={[
            {
              validator: isRequired,
              message: "Bitte geben Sie Ihre Telefonnummer an",
            },
            ...isPhoneNumberDefault,
          ]}
        />
      </Grid>
      {withContactTime && (
        <Grid
          size={{
            xs: 12,
            sm: 6
          }}>
          <ValidatorSelectField label={translate("person.contactTime.label", values)} name={`${path}.contactTime`}>
            {_map(serviceTimes(), (serviceTimeSlot, value) => (
              <MenuItem key={value} value={value}>
                {translate(`person.contactTime.options.${value}.label`, values)}
              </MenuItem>
            ))}
          </ValidatorSelectField>
        </Grid>
      )}
    </>
  );
}
